/**
 * Adds or deletes an item to the cart.
 * @param {number|string} itemId
 * @param {string} itemName
 */
const addItemToCart = (itemId, itemName) => {
  let cart = JSON.parse(sessionStorage.getItem("JCOre_cart"));
  if (!cart) cart = [];
  if (cart.filter((c) => c.itemId === itemId).length === 0) {
    cart.push({ itemId: itemId, itemName: itemName });
    sessionStorage.setItem("JCOre_cart", JSON.stringify(cart));
    createCartElement(cart);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "add-to-cart",
      product: itemName,
    });
  } else {
    deleteItem(itemId);
  }
};

/**
 * Clears the cart
 */
export const clearCart = () => {
  sessionStorage.removeItem("JCOre_cart");
};

/**
 * Deletes a specific item from the cart.
 * @param {number|string} id
 */
export const deleteItem = (id) => {
  let cart = JSON.parse(sessionStorage.getItem("JCOre_cart"));
  if (!cart) return;
  let newCart = cart.filter((item) => {
    if (item.itemId === id) return false;
    return true;
  });
  sessionStorage.setItem("JCOre_cart", JSON.stringify(newCart));
  createCartElement(newCart);
  unsetButton(id);
};

/**
 * Creates the cart element
 * @param {array} cart The cart from sessionStorage
 */
const createCartElement = (cart) => {
  const existingCart = document.querySelector(".cart-wrapper");
  if (existingCart) existingCart.remove();
  if (cart.length === 0) return;

  const cartEl = document.createElement("div");
  cartEl.className = "cart-wrapper";
  cartEl.addEventListener("click", cartClicked);

  const cartIconEl = document.createElement("i");
  cartIconEl.className = "fas fa-shopping-cart";

  const cartNumberEl = document.createElement("span");
  cartNumberEl.className = "cart-number";
  cartNumberEl.textContent = cart.length.toString();

  cartEl.appendChild(cartIconEl);
  cartEl.appendChild(cartNumberEl);
  let tuoteEl = document.querySelector(".post-type-archive-tuotteet");
  if (tuoteEl) tuoteEl.appendChild(cartEl);
  tuoteEl = document.querySelector(".tax-tuotekategoria");
  if (tuoteEl) tuoteEl.appendChild(cartEl);
  checkButtons(cart);
};

const cartClicked = () => {
  let cart = JSON.parse(sessionStorage.getItem("JCOre_cart"));
  if (!cart) return;
  let queryString = "?tuoteet=";
  cart.forEach((element, i) => {
    let q = encodeURIComponent(element.itemId);
    queryString = i === 0 ? `${queryString}${q}` : `${queryString},${q}`;
  });
  window.location.assign(`/tarjouspyynto${queryString}`);
};

const unsetButton = (id) => {
  const button = document.querySelector(`[data-product-id="${id}"]`);
  if (button && button.classList.contains("in-cart"))
    button.classList.remove("in-cart");
};

const checkButtons = (cart) => {
  cart.forEach((items) => {
    const button = document.querySelector(
      `[data-product-id="${items.itemId}"]`
    );
    if (button && !button.classList.contains("in-cart"))
      button.classList.add("in-cart");
  });
};

window.addEventListener("load", () => {
  let cart = JSON.parse(sessionStorage.getItem("JCOre_cart"));
  if (!cart) cart = [];
  createCartElement(cart);
});

// @ts-ignore
window.addItemToCart = addItemToCart;
// @ts-ignore
window.clearCart = clearCart;
